import { AloBase, getDefaultAloBase } from './AloBase'


export interface AloForfait extends AloBase {      
    fftIsAbo:boolean
    fftEnable:boolean
    fftLimiteAchat:number|null
    fftValiditeM:number|null
    fftNbEntree:number|null
    fftTarif:number|null 
    fftInfos:string
    acyIds:Array<number>
    psnIds:Array<number>
    tva:number
}

export const getDefaultAloForfait = ():AloForfait => {
    return {  
        ...getDefaultAloBase(),
        fftIsAbo:false,
        fftEnable:false,
        fftLimiteAchat:null,
        fftValiditeM:null,
        fftNbEntree:null,
        fftTarif:null,
        fftInfos:'',
        acyIds:[],
        psnIds:[],
        tva:2000
    }
}

export const cleanAloForfait = (forfait:AloForfait) => {
    if(!forfait) return    
    if(!forfait.id) delete forfait.id
    
}